"use strict";
import React from "react";
import {Redirect, useHistory} from "react-router-dom";

import {useStore} from "../hooks/useStore";
import {getStartRoute} from "../utils/getStartRoute";

export const AuthChecker = props => {
    const stores = useStore();
    const history = useHistory();
    const RenderComponent = props.RenderComponent;
    const tempProp = {...props};
    tempProp.RenderComponent = undefined;
    const {role, isLoggedIn, checkRole} = stores.meStore;
    if (isLoggedIn && (!props.roles || (props.roles && props.roles.includes(role)))) {
        return RenderComponent && <RenderComponent {...tempProp} />;
    }
    if (!isLoggedIn) {
        stores.appStore.setBeforeLogin(history.location.pathname + history.location.search);
        return <Redirect to="/login" />;
    }

    if (checkRole("isUatPoolCustomer")) {
        return <Redirect to="/musteri" />;
    }

    const startRoute = getStartRoute({
        role,
        isPoolCustomer: stores.meStore.isPoolCustomer,
        isUatCustomer: stores?.meStore?.isUatCustomer
    });
    return <Redirect to={startRoute} />;
};
